import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBellActive: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBellActive"><Path d="M4.36407 9.36759C4.77896 5.46268 8.07312 2.5 12 2.5C15.9269 2.5 19.221 5.46269 19.6359 9.3676L20.5 17.5H3.5L4.36407 9.36759Z" stroke="currentColor"/><Path d="M16 17.5C16 19.7091 14.2091 21.5 12 21.5C9.79086 21.5 8 19.7091 8 17.5" stroke="currentColor"/><Path d="M1.8291 7C2.49394 4.99386 3.81843 3.26548 5.46206 2M18.5385 2C20.1821 3.26548 21.5065 4.99386 22.1714 7" stroke="currentColor"/></CentralIconBase>;
});

export default IconBellActive;
